import React from 'react';
import { useTheme } from '@emotion/react';
import { Box, Grid } from '@mui/material';
import Shimmer from 'ui-components/Shimmer';

// Placeholder shaped like AnalysisCard.js. Every number below comes from that file,
// so the grid does not resize when the real cards land.
const AllAnalysisResultsSkeleton = () => {
  const theme = useTheme();
  const c = theme.palette.customColors;

  const skeletonCards = Array(8).fill(0);

  return (
    <Box sx={{ padding: { xs: '0rem', sm: '0 0rem 0rem 0rem' } }}>
      {/* Grid spacing matches AllAnalysisResults' results grid. */}
      <Grid container spacing={2.5} rowSpacing={{ xs: 2.5, sm: 2.5, md: 3 }}>
        {skeletonCards.map((_, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Box
              sx={{
                border: `1px solid ${c.gray300}`,
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: '#fff',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                maxWidth: { xs: '100%', sm: '25rem' },
                marginInline: 'auto',
              }}
            >
              {/* Thumbnail: 16/9, not a fixed height - that is what made the card taller. */}
              <Shimmer width="100%" height="auto" radius={0} sx={{ aspectRatio: '16 / 9' }} />

              <Box sx={{ padding: { xs: '0.75rem', sm: '1rem' }, flex: 1, display: 'flex', flexDirection: 'column' }}>
                {/* Name and verdict chip share one row; chip is 22px tall. */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, gap: 0.5 }}>
                  <Shimmer width="55%" height={16} radius={4} />
                  <Shimmer width={74} height={22} radius={11} />
                </Box>
                {/* "Report 1 · 24-Jul-2026" */}
                <Shimmer width="70%" height={12} radius={4} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Shimmer width={40} height={40} radius={8} />
          <Shimmer width={60} height={16} radius={4} />
          <Shimmer width={40} height={40} radius={8} />
        </Box>
      </Box>
    </Box>
  );
};

export default AllAnalysisResultsSkeleton;
